export default "__VITE_ASSET__Cm74GcGH__"